<div class="modal-header">
    <h4 class="modal-title pull-left">{{title}}</h4>
  <button *ngIf="showCloseButton"
          type="button"
            class="close pull-right"
            aria-label="Close"
            data-dismiss="modal"
            (click)="closeButtonClicked()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <ng-container *ngIf="message">
        {{message}}
    </ng-container>
    <ng-content>
    </ng-content>
</div>
<div class="modal-footer">
    <button type="button"
            class="btn"
            *ngFor="let item of getButtons()"
            [class.btn-primary]="item.primary"
            [class.btn-default]="!item.danger && !item.primary"
            [class.btn-danger]="item.danger"
            (click)="buttonClicked(item)">
        {{item.text}}
    </button>
</div>
